export default __webpack_public_path__ + "assets/633a4b7202e4b8cead7e5a34d534eb38.svg";